export default function(value: any) {
  if (!value) return
  return value.replace(",", ".")
}
